import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-data-table-container',
  imports: [],
  templateUrl: './data-table-container.component.html',
  styleUrl: './data-table-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block bg-white rounded-[inherit] flex flex-col overflow-hidden',
  },
})
export class DataTableContainerComponent {}
